var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.158,
    height: 19.158,
    viewBox: "0 0 19.158 19.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#86e528;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-62.242 -32.242)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.179,6.6a9.579,9.579,0,1,0,9.579,9.579A9.57,9.57,0,0,0,16.179,6.6Zm4.635,7.592-5.672,5.65a.872.872,0,0,1-.618.265.835.835,0,0,1-.618-.265l-2.8-2.781A.89.89,0,0,1,12.361,15.8l2.163,2.163,5.032-5.032a.879.879,0,0,1,1.258,0A.921.921,0,0,1,20.814,14.192Z",
    transform: "translate(55.642 25.642)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.67acd46e03f7220870dcf7a1be7f7ded.svg";
export { ForwardRef as ReactComponent };